<template>
  <v-container fluid class="pa-0">
    <v-card class="pt-3 pb-7 ub-3" flat>
      <v-card-title class="headline">Редактирование свойств</v-card-title>
      <v-card-text>
        <v-form v-model="isValid">
          <v-row>
            <v-col cols="12" md="5" class="pb-0">
              <v-text-field
                label="Дилер"
                v-model="master.dealerName"
                :rules="[notEmptyRule]"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5" class="pb-0">
              <v-text-field
                label="Модуль ПО"
                v-model="master.moduleName"
                :rules="[notEmptyRule]"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="pb-0">
              <v-text-field
                label="Количество"
                type="number"
                v-model="master.count"
                :rules="[notEmptyRule, biggerThanCurrent]"
              ></v-text-field>
            </v-col>

            <v-col cols="12" class="pt-1">
              <v-text-field
                label="Объект"
                v-model="formatObject"
                :rules="[notEmptyRule]"
                readonly
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-row>
                <v-col cols="auto">
                  <v-checkbox
                    label="Шоурум"
                    v-model="master.showroom"
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-text-field
                    v-if="master.showroom"
                    label="Деньги платит кому"
                    value="Никому, это шоурум"
                    readonly
                  ></v-text-field>
                  <v-select
                    v-else
                    :items="choices.ourLegalEntities"
                    label="Деньги платит кому"
                    v-model="master.moneyFor"
                    :rules="[notEmptyRule]"
                    counter="100"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-textarea
                label="Доп. инфо"
                class="pt-0"
                :rows="3"
                v-model="master.comment"
              ></v-textarea>
            </v-col>

            <v-col cols="12" md="7">
              <v-card>
                <v-card-title>Управление датой окончания</v-card-title>
                <v-card-text>
                  <div class="d-flex justify-space-around flex-wrap">
                    <v-btn class="mb-4" color="green" dark @click="addDays(10)"
                      >+10 дней
                    </v-btn>
                    <v-btn class="mb-4" color="green" dark @click="addMonths(1)"
                      >+30 дней
                    </v-btn>
                    <v-btn class="mb-4" color="#dcaa00" dark @click="addSpecificMonth()"
                      >+1 мес
                    </v-btn>
                    <v-btn class="mb-4" color="green" dark @click="addMonths(3)"
                      >+3 мес
                    </v-btn>
                    <v-btn
                      class="mb-4"
                      color="green"
                      dark
                      @click="addMonths(12)"
                      >+1 год
                    </v-btn>
                    <v-btn
                      class="mb-4"
                      color="primary darken-2"
                      dark
                      @click="setMaxDate()"
                      >max дата
                    </v-btn>
                  </div>

                  <v-menu
                    ref="menu1"
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="master.expires"
                        label="Мастер-лицензия действует включительно до"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        @blur="date = parseDate(master.expires)"
                        v-on="on"
                        readonly
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      no-title
                      @input="dateMenu = false"
                      :first-day-of-week="1"
                      locale="ru-RU"
                    ></v-date-picker>
                  </v-menu>

                  <v-checkbox
                    class="mt-0"
                    label="Обновить дату лицензий"
                    v-model="master.resetLicensesDate"
                    hint="Срок действия лицензий станет таким же, как и у мастер-лицензии"
                    persistent-hint
                  ></v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="5" v-if="master.features.length > 0">
              <v-card>
                <v-card-title class="pb-0">Управление фичами</v-card-title>
                <v-card-text>
                  <v-checkbox
                    v-for="feature in master.features"
                    :key="feature.id"
                    v-model="feature.included"
                    :label="feature.name"
                    hide-details
                  ></v-checkbox>
                </v-card-text>
              </v-card>
            </v-col> 
          <template v-if="history.length === 0">
            <v-col cols="12" sm="6">
              <v-text-field
                label="Изменил"
                v-model="master.creatorName"
                disabled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Дата последнего изменения"
                v-model="formatUpdateTime"
                disabled
                hide-details
              ></v-text-field>
            </v-col>  
          </template>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          text
          @click="updateMasterData"
          :disabled="!isValid"
          >Сохранить
        </v-btn>
      </v-card-actions>
      <v-card class="mt-6"  flat v-if="history.length > 0">
        <v-card-title class="headline">История изменений</v-card-title>
        <v-data-table
          :headers="historyHeaders"
          :items="history"
          :items-per-page="10"
          disable-sort
          class="elevation-1"
        >
          <template #item.date="{ item }">
            {{ formattedDate(item.date) }}
          </template>
          <template #item.valid_until="{ item }">
            {{ new Date(item.valid_until).toLocaleDateString() }}
          </template>
          <template #item.money_for="{ item }">
            {{ defineById(item) }}
          </template>
          <template #item.action="{ item }">
            {{ getActionLabel(item.action) }}
          </template>
        </v-data-table>
      </v-card>
    </v-card>

    <v-dialog v-model="dateWarning" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Внимание</v-card-title>
        <v-card-text
          >Указанная дата окончания мастер-лицензии приходится на выходной
          день</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dateWarning = false"
            >Продолжить</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import API from "@/axios/api";

import FormatDateTime from "@/utils/time.js";

export default {
  props: ["masterId"],
  data() {
    return {
      master: {
        features: [],
        expires: null,
        moneyFor: ""
      },
      historyVisible: false,
      history: [],
      currentCount: 0,
      choices: {
        ourLegalEntities: [],
      },
      isValid: true,
      notEmptyRule: (v) => !!v || "Поле не может быть пустым",
      biggerThanCurrent: (v) =>
        (v && v >= this.currentCount) || "Уменьшать кол-во нельзя",
      length100: (v) =>
        !v || v === "" || (v && v.length <= 100) || "Максимум 100 символов",

      dateWarning: false,
      date: null,
      dateMenu: false,

      historyHeaders: [
        { text: 'Дата / время', value: 'date' },
        { text: 'ФИО', value: 'creator_name' },
        { text: 'Дата действия лицензии', value: 'valid_until' },
        { text: 'Доп. инфо', value: 'comment' },
        { text: 'Деньги кому', value: 'money_for' },
        { text: 'Действие', value: 'action' }
      ],
    };
  },
  watch: {
    date() {
      this.master.expires = this.formatDate(this.date);
      if (
        new Date(this.date).getFullYear() < 2100 &&
        [6, 5].includes(new Date(this.date).getDay())
      ) {
        this.dateWarning = true;
      }
    },
    "master.expires"() {
      this.date = this.parseDate(this.master.expires);
    },
  },
  computed: {
    formatObject() {
      return `${this.master.objectName} (${this.master.objectId})`
    },

    formatUpdateTime() {
      if (this.master.updateTime == null) return "";
      return FormatDateTime(this.master.updateTime);
    },
  },
  methods: {
    getIsoDate(date) {
      return date.toISOString().substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    formattedDate(date) {
      const date_ = new Date(date);
      const day = String(date_.getUTCDate()).padStart(2, '0');
      const month = String(date_.getUTCMonth() + 1).padStart(2, '0');
      const year = date_.getUTCFullYear();
      const hours = String(date_.getUTCHours()).padStart(2, '0');
      const minutes = String(date_.getUTCMinutes()).padStart(2, '0');
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    },
    getActionLabel(action) {
      const labels = {
        CREATE: "Создание",
        EXTENSION: "Продление",
        DELETE: "Удаление",
        RECOVERY: "Восстановление"
      };
      return labels[action] || action;
    },  
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    addDays(days) {
      let date = new Date();
      this.date = this.getIsoDate(
        new Date(date.setDate(date.getDate() + days))
      );
    },
    addMonths(months) {
      let date = new Date();
      this.date = this.getIsoDate(
        new Date(date.setMonth(date.getMonth() + months))
      );
    },
    addSpecificMonth(){
      let date = new Date();
      date.setMonth(date.getMonth() + 1);
      date.setDate(5);
      let day_of_week = date.getDay();
      if (day_of_week === 0){ // Воскресенье
        date.setDate(7);
      }
      else if (day_of_week == 1){ // Понедельник
        date.setDate(6);
      }
      else if (day_of_week == 2){ // Втоник
        date.setDate(5);
      }
      else if (day_of_week == 3){ // Среда
        date.setDate(6);
      }
      else if (day_of_week == 4){ // Четверг
        date.setDate(5);
      }
      else if (day_of_week == 5){ // Пятница
        date.setDate(4);
      }
      else if (day_of_week == 6){ // Суббота
        date.setDate(3);
      }
      this.date = this.getIsoDate(date);

    },
    setMaxDate() {
      this.date = this.getIsoDate(new Date(Date.UTC(2100, 1, 1)));
    },
    back() {
      history.back();
    },
    async getMasterData() {
      await API.get(`masters/${this.masterId}`)
        .then((response) => {
          console.log(response.data);
          this.master = response.data.master;
          this.history = response.data.history;
          this.date = this.master.expires;
          this.master.expires = this.formatDate(this.date);
          this.currentCount = this.master.count;
          this.$set(this.master, "resetLicensesDate", true);
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message)
            this.$store.commit("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
        });
    },
    updateMasterData() {
      API.post(`masters/${this.masterId}`, this.master)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("showSnackbar", {
            color: "success",
            text: "Свойства Мастер-лицензии обновлены",
          });

          this.currentCount = this.master.count;
          this.getMasterData();
          this.$store.dispatch("updateMasters");
          this.$emit("update");
        })
        .catch((error) => {
          this.$store.dispatch("showSnackbar", {
            color: "error",
            text: "Свойства Мастер-лицензии не обновлены",
          });
          console.log(error);
        });
    },
    async getOurLegalEntitiesChoices() {
      await API.get('our_legal_entities/list_for_choices')
        .then((response) => {
          console.log(response.data)
          this.choices.ourLegalEntities = response.data.choices
        })
        .catch((error) => {
          console.error(error)
        })
    },
    defineById(item) {
      if (item.showroom === true) return "Никому, это шоурум";
      
      const q = this.choices.ourLegalEntities.find(
        (entity) => String(entity.value) === String(item.money_for)
      );
      return q?.text || "-";
    }
  },
  async created() {
    await Promise.all([
      this.getMasterData(),
      this.getOurLegalEntitiesChoices()
    ])
    this.$emit("ready")
  },
};
</script>

<style>
.v-label--is-disabled {
  color: rgba(0, 0, 0, 0.6) !important;
}

.v-chip--disabled {
  opacity: 1 !important;
}

input:disabled {
  color: rgba(0, 0, 0, 1) !important;
}
</style>